import { render, staticRenderFns } from "./rewardAdmin.vue?vue&type=template&id=fe878156&scoped=true"
import script from "./rewardAdmin.vue?vue&type=script&lang=js"
export * from "./rewardAdmin.vue?vue&type=script&lang=js"
import style0 from "./rewardAdmin.vue?vue&type=style&index=0&id=fe878156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe878156",
  null
  
)

export default component.exports